const globals = {
  token: 'f4df9afa-c8d4-4ea2-aa52-f6a660f27b3c',
  //apiBaseUrl: 'https://streaming.contratoonline.tec.br'
  //apiBaseUrl: 'http://localhost:8000'
  apiBaseUrl: 'https://painel2k20.contratoonline.tec.br'
};

export default globals;